import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
    const location = useLocation();
    // Automatically scrolls to top whenever route changes
    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      const el = document.scrollingElement;
      if (el) el.scrollTop = 0;
    }, [location]);

    return <>
        {props.children}
    </>
  };

export default ScrollToTop;